import React from 'react'
import Header from '../../component/Header'
import ALevel from '../ALevel'
import Footer from '../../component/Footer'

export default function LayoutALevel() {
    return (
        <div>
            <Header />
            <ALevel />
            <Footer />
        </div>
    )
}
